import React from "react";
import { ForumOutlined as ChatIcon } from "@mui/icons-material";

function EmptyChat() {
  return (
    <div className="empty-chat">
      <ChatIcon className="empty-chat__icon" />
      <span className="empty-chat__title">Welcome to Chat</span>
      <span className="empty-chat__subtitle">Select a conversation or start a new chat</span>
    </div>
  );
}

export default EmptyChat;
